export * from './pressable'
console.warn(`@motify/interactions is deprecated. It has moved to 'moti/interactions'. Please uninstall @motify/interactions, upgrade "moti", and update your imports. https://github.com/nandorojo/moti/pull/136

yarn remove @motify/interactions
yarn add moti

Finally, find and replace all your imports.
`)
